import styled from 'styled-components';

export const StyledMenu = styled.nav`
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
  height: 100vh;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9;
  transition: transform 0.3s ease-in-out;
  background: #fff;
  width: 300px;
  overflow-y: scroll;

  li {
    background: #fff;
    border-bottom: solid 1px #ccc;
    transition: all 0.5s ease-in-out;
  }
  
  li.isActive,
  li:hover {
    background: #000;
  }

  li.isActive a,
  li:hover a {
    color: #fff;
  }

  li.isActive svg, 
  li:hover svg {
    fill: #fff;
  }
`;
